<app-appointment-notification *ngFor="let appointment of appointments" [dto]="appointment" (deletion)="removeAppointment(appointment.appointment.id)"></app-appointment-notification>
